import APIConnection from '@/API/APIConnection';
export default {
    get(){
        return APIConnection.get('home', APIConnection.mainInterceptor);
    },
    getBySlug(slug){
        return APIConnection.get(`home/${slug}`, APIConnection.mainInterceptor);
    },
}